const AUTO_REPLY_CONTACT_METHOD = 'Auto Response'

/**
 * Contacted tab contract: a lead is contacted only when the coach recorded a
 * contact method via Mark as Contacted (`setCoachingLeadContact`). Auto-replies
 * set `contactMethod` to "Auto Response" and remain on the New tab even when
 * `contactedAt` is set. Legacy rows with only `contactedAt` and a null
 * `contactMethod` also stay on New until the coach picks a method.
 */
export function isLeadContacted(lead) {
  const method = lead?.contactMethod
  return Boolean(method) && method !== AUTO_REPLY_CONTACT_METHOD
}

export function isUnviewedNewLead(lead) {
  return !isLeadContacted(lead) && lead?.viewedAt == null
}

export function partitionLeadsByContactStatus(leads = []) {
  const awaitingResponseLeads = leads.filter(lead => !isLeadContacted(lead))
  const contactedLeads = leads.filter(lead => isLeadContacted(lead))

  return { awaitingResponseLeads, contactedLeads }
}
